import { CdaStructuredTextRecord } from 'react-datocms/structured-text';
import { FeatureBlock as FeatureCard, Icon, type IconName } from '@carbonify/ui';
import CtaButton from 'components/CtaButton';

interface FeatureBlockRecord extends CdaStructuredTextRecord {
  icon?: { icon: IconName };
  title?: string;
  subtitle?: string;
  cta?: string;
}

export default function FeatureBlock({ title, subtitle, cta, icon }: FeatureBlockRecord) {
  return (
    <FeatureCard
      title={title}
      subtitle={subtitle}
      cta={cta && <CtaButton variant="ghost">{cta}</CtaButton>}
      icon={icon && <Icon name={icon} />}
    />
  );
}
